import React, { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { AiDialogFooter, MagicAiIcon, palette } from '@dev/ee-components';
import { useDispatch, useSelector } from 'react-redux';
import { AiTextGenerateStart, AiTextSetInputValue, getAiTextStore } from '@/store/aiText/actions';
import { AiTextItemType } from '@/store/aiText/types';
import { AI_TEXT_CONTEXT } from '../../constants';
import { useAreNewPromptsDisabled } from '../../hooks/useAreNewPromptsDisabled';
import { AiTextModalFooterWrapper } from './styles';

export const AiTextModalFooter = ({
    inputWrapperRef,
}: {
    inputWrapperRef: MutableRefObject<HTMLDivElement>;
}): JSX.Element => {
    const dispatch = useDispatch();
    const { areNewPromptsDisabled } = useAreNewPromptsDisabled();
    const { isBusy, inputValue } = useSelector(getAiTextStore);
    const { t } = useTranslation();

    const setInputValue = (value: string): void => {
        dispatch(AiTextSetInputValue(value));
    };

    const onGenerateClick = (): void => {
        if (isBusy) {
            return;
        }
        dispatch(
            AiTextGenerateStart({
                type: AiTextItemType.GENERATE,
                timestamp: Date.now(),
                context: AI_TEXT_CONTEXT,
                request: inputValue,
            })
        );
    };

    return (
        <AiTextModalFooterWrapper ref={inputWrapperRef}>
            <AiDialogFooter
                isLoading={isBusy}
                placeholder={t('aitexttool_promptplaceholder')}
                buttonText={t('generate')}
                buttonOnClick={onGenerateClick}
                isDisabled={areNewPromptsDisabled || !inputValue?.length}
                icon={<MagicAiIcon color={!inputValue?.length ? palette.gray[4] : palette.basic.paper} />}
                inputValue={inputValue}
                inputOnValueChange={setInputValue}
                inputIsDisabled={areNewPromptsDisabled}
                useEnterKey
            />
        </AiTextModalFooterWrapper>
    );
};
